import { render } from "./PForm.vue?vue&type=template&id=5cc2b0d5&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./PForm.vue?vue&type=script&lang=js"
export * from "./PForm.vue?vue&type=script&lang=js"

import "./PForm.vue?vue&type=style&index=0&id=5cc2b0d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc2b0d5"]])

export default __exports__